module.exports = __webpack_public_path__ + "static/media/ic_cross.09942e9f.svg";